import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { TokenService } from '../services/token.service';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { SessionExpiredDialogComponent } from '../shared/components/session-expired-dialog/session-expired-dialog.component';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private isLoggingOut = false;

  constructor(
    private tokenService: TokenService,
    private router: Router,
    private store: Store,
    private dialog: MatDialog
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    /* 🚫 Skip auth APIs */
    if (
      req.url.includes('/auth/sign-in') ||
      req.url.includes('/auth/sign-up')
    ) {
      return next.handle(req);
    }

    /* 🔐 Attach token */
    const token = this.tokenService.getAccessToken();

    const authReq = token
      ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      })
      : req;

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {

        /* 🔴 Token expired / invalid / logged in another device */
        if (error.status === 401 && !this.isLoggingOut && !req.url.includes('/auth/logout')) {
          this.isLoggingOut = true;

          console.warn('🔴 Session expired or logged in another device');

          const dialogRef = this.dialog.open(SessionExpiredDialogComponent, {
            disableClose: true,
            panelClass: ['session-dialog-container']
          });

          dialogRef.afterClosed().subscribe(() => {

            this.tokenService.clearAll();
            this.store.dispatch({ type: '[Auth] Logout' });

            this.router.navigate(['/auth/sign-in']).then(() => {
              this.isLoggingOut = false;
            });

          });
        }

        return throwError(() => error);
      })
    );
  }
}
